import React from 'react';
import './AboutDeveloper.css';
import emekaImage from './emeka.jpg';
import cvFile from '../assets/images/Emeka_Aniekwensi_CV.pdf';
import showcaseFile from '../assets/images/Emeka Aniekwensi Engineering symposium poster.pdf';

const AboutDeveloper = () => {
  return (
    <div className="developer-container">
      <h1 className="text-3xl font-bold">About the Developer</h1>
      <img src={emekaImage} alt="Developer" className="profile-img" />
      <p className="mt-4 text-lg">
        Emeka Aniekwensi is a researcher and developer specializing in environmental data analysis.
      </p>
      <div className="social-links">
        <a
          href="https://www.linkedin.com/in/emeka-aniekwensi-83a84620a/"
          className="linkedin-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          View LinkedIn Profile
        </a>
        <a
          href="https://github.com/jorelix/"
          className="github-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          View GitHub Profile
        </a>
      </div>
      <div className="cv-link">
        <h2 className="text-xl font-semibold mt-6">View CV</h2>
        <a
          href={cvFile}
          className="cv-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open CV
        </a>
      </div>
      <div className="showcase-link">
        <h2 className="text-xl font-semibold mt-6">Showcase</h2>
        <a
          href={showcaseFile}
          className="showcase-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Showcase
        </a>
      </div>
    </div>
  );
};

export default AboutDeveloper;